// extracted by mini-css-extract-plugin
module.exports = {"categoryBanner":"categoryBanner_categoryBanner__2OBGp","categoryTag":"categoryBanner_categoryTag__iHAVW","selected":"categoryBanner_selected__11Iur"};